import { Skeleton } from "@mui/material";
import { memo } from "react";

export const LoadingBeneficiary = memo(() => {
  return (
    <Skeleton
      variant="rectangular"
      sx={(t) => ({
        minWidth: 300,
        maxWidth: 800,
        height: 90,
        borderRadius: t.shape.borderRadius,
      })}
    />
  );
});
